module.exports = __webpack_public_path__ + "static/media/time.b3d0ee91.svg";